<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-10-24 11:11:18
 * @LastEditors: caizexin caizexin@kjgb.net
-->
<template>
    <div>
        <a-tabs :active-key="activeKey" @change="tabClick">
            <a-tab-pane key="0" :title="$t('stock.shipment')"></a-tab-pane>
            <a-tab-pane key="1" :title="$t('stock.return')"></a-tab-pane>
            <a-tab-pane key="2" :title="$t('stock.exchange')"></a-tab-pane>
            <a-tab-pane key="3" :title="$t('stock.reissue')"></a-tab-pane>
            <a-tab-pane key="4" :title="$t('stock.returnFactory')"></a-tab-pane>
        </a-tabs>
         
        <!-- 出库 -->
        <div v-if="activeKey == '0'">
            <Table 
                class="deliverTable"
                :table="logisticsTable"
            >
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'status'">
                        <a-tag v-if="props.record.status !== '-'" :color="getoOderStatus('outboundStatus', props.record.status)">{{ props.record.status }}</a-tag>
                        <span v-else>{{props.record.status}}</span>
                    </div>
                    <div v-if="props.column.key == 'courier_status'">
                        <a-tag v-if="props.record.courier_status !== '-'" :color="getoOderStatus('badgeCourierStatus', props.record.courier_status)">{{ props.record.courier_status }}</a-tag>
                        <span v-else>{{props.record.courier_status}}</span>
                    </div>
                </template>

                <template v-slot:tableOperate="{ props }">
                    <a-button type="primary" size="mini" :disabled="!props.record.courier_id || props.record.courier_type == 'Factory'" @click="handle('logisticsDetail',props.record)">{{ $t('order.logisticsDetail') }}</a-button>
                </template>
            </Table>
        </div>

        <!-- 退货，换货，补寄，返修 -->
        <div v-if="activeKey == 1 || activeKey == 2 || activeKey == 3 || activeKey == 4">
            <Table 
                class="deliverTable"
                :table="returnTable"
            >
                <template v-slot:editCourierStatus="{ props }">
                    <a-tag v-if="props.record.courier_status !== '-'" :color="getoOderStatus('badgeCourierStatus', props.record.courier_status)">{{ props.record.courier_status }}</a-tag>
                    <span v-else>{{props.record.courier_status}}</span>
                </template>

                <template v-slot:tableOperate="{ props }">
                    <a-button type="primary" size="mini" :disabled="!props.record.courier_id || props.record.courier_type == 'Factory'" @click="handle('logisticsDetail',props.record)">{{ $t('order.logisticsDetail') }}</a-button>
                </template>
            </Table>
        </div>


        <!-- 物流明细 -->
        <a-modal 
            class="recordModal"
            v-model:visible="stepVisible"
            width="45%"
            :footer="false"
        >   
            <template #title>
               <div style="font-weight:bold">{{ $t('order.logisticsDetail') }}</div> 
            </template>

            <div class="courierNo">{{$t('order.courierNo')}}：{{ courier_no }}</div>
            <a-spin :loading="loading" tip="Loading..." style="width:100%">
                <a-steps
                    v-if="stepList.length > 0"
                    :current="currentStep"
                    direction="vertical"
                    type="dot"
                >
                    <a-step 
                        v-for="(item,index) in stepList"
                        :key="index"
                        :description="item.date"
                    >
                        {{ item.name }}
                        <div class="courierMesg" >
                            <slot name='description'>{{item.message}}</slot>
                        </div>
                    </a-step>
                </a-steps>
                <div v-else>{{ $t('order.noCourierInfo') }}</div>
            </a-spin>
            
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';

    const props = defineProps({
        row:{
            type:Object,
            default:()=>{}
        },
        visible:{
            type:Boolean,
            default:false,
        },
        courierStatus:{
            type:Object,
            default:()=>{} 
        },
        outboundStatus:{
            type:Object,
            default:()=>{} 
        }
    })

    const { t } = useI18n()
    const activeKey = ref('0')
    const loading = ref(false)
    const stepVisible = ref(false)
    const stepList = ref([])
    const courier_no = ref()
    const currentStep = ref()
    const logisticsTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
            },
            {
                // title: '订单编号',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '140',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '车型',
                title:t('order.model'),
                dataIndex: 'model',
                key:'model',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 上市年份',
                title:t('order.modelYear'),
                dataIndex: 'model_year',
                key:'model_year',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '品牌名称',
                title:t('order.brandName'),
                dataIndex: 'brand_name',
                key:'brand_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '零件名称',
                title:t('order.partName'),
                dataIndex: 'part_name',
                key:'part_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '出库状态',
                title:t('order.outboundStatus'),
                dataIndex: 'status',
                key:'status',
                width:'160',
                align:'center',
                slotName:'slot',
            },
            {
                // title: '物流单号',
                title:t('order.courierNo'),
                dataIndex: 'courier_no',
                key:'courier_no',
                width:'180',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: '物流状态',
                title:t('order.courierStatus'),
                dataIndex: 'courier_status',
                key:'courier_status',
                width:'150',
                align:'center',
                slotName:'slot',
            },
            {
                // title: '物流公司',
                title:t('order.courierType'),
                dataIndex: 'courier_type',
                key:'courier_type',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物流更新日期',
                title:t('order.happenedTime'),
                dataIndex: 'happened_time',
                key:'happened_time',
                width:'180',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: 'erp行号',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                key:'erp_line_no',
                width:'170',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '150',
                align: 'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })
    const returnTable = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
            },
            {
                // title: '订单编号',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '140',
                align: 'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '车型',
                title:t('order.model'),
                dataIndex: 'model',
                key:'model',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: 上市年份',
                title:t('order.modelYear'),
                dataIndex: 'model_year',
                key:'model_year',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '品牌名称',
                title:t('order.brandName'),
                dataIndex: 'brand_name',
                key:'brand_name',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '零件名称',
                title:t('order.partName'),
                dataIndex: 'part_name',
                key:'part_name',
                width:'120',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物流单号',
                title:t('order.courierNo'),
                dataIndex: 'courier_no',
                key:'courier_no',
                width:'180',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: '物流状态',
                title:t('order.courierStatus'),
                dataIndex: 'courier_status',
                key:'courier_status',
                width:'150',
                align:'center',
                slotName:'courier_status',
            },
            {
                // title: '物流公司',
                title:t('order.courierType'),
                dataIndex: 'courier_type',
                key:'courier_type',
                width:'150',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物流更新日期',
                title:t('order.happenedTime'),
                dataIndex: 'happened_time',
                key:'happened_time',
                width:'180',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                // title: 'erp行号',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                key:'erp_line_no',
                width:'170',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'160',
                align:'center',
                tooltip:true,
                ellipsis:true,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '150',
                align: 'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const cargoBoardCourierDetail = ref({
        // Cargoboard 物流CODE
        '00':'Shipment scanned - no differences',
        '05':'Shipment has not yet arrived at the receiving depot',
        '14':'Delivery planned',
        '20':'Not in delivery',
        '29':'In forwarding',
        '33':'Collection obstacle',
        '40':'Shipment in delivery',
        '49':'Arrival at the consignee',
        '50':'Shipment has been delivered',
        '52':'Delivered, with damage',
        '57':'Not delivered',
        '65':'Acceptance refused, not ordered',
        '67':'Not delivered, closed',
        '68':'Not delivered',
        '70':'Not delivered',
        '91':'Proof of Delivery archived',
        '401':'Document archived',
        '500':'Consignment collected',
        '510':'Consignment loaded at receiving depot',
        '521':'Unsuccessful pick-up attempt, no one encountered',
        '523':'Unsuccessful collection attempt, collection address incorrect',
        '526':'Unsuccessful collection attempt, not packed securely for transport',
        '528':'Unsuccessful collection attempt, not yet ready for dispatch',
        '529':'Unsuccessful collection attempt, goods no longer on site',
        '533':'Appointment received for...',
        '540':'In collection',
        '549':'Arrival at the loading point',
        '550':'Not picked up - lack of time',
        '552':'Not picked up',
        '721':'Unsuccessful advice attempt',
        '722':'Notification by Email/SMS is made',
        '724':'Appointment confirmation received',
        '729':'Estimated time of arrival updated',
        '751':'Delivery obstacles Premium product',
        '805':'Collection not performed - We are checking',
        '840':'Claim was created',
        '841':'Documents submitted on the claim',
        '844':'Documents sent to insurance company / underwriter',
        '845':'Documents sent to insuranceInquiry made to applicant',
        '853':'Regulation rejected',
        '899':'Order canceled',
        '900':'Delivery obstacle',
        '901':'Collection obstacle',

        // DHL 物流CODE
        'pre-transit':'Pre-Transit',
        'transit':'Transit',
        'delivered':'Delivery successful',
        'failure':'Failure',
        'unknown':'Unknown',
    })

    const tabClick = (val)=>{
        activeKey.value = val
    }


    const getoOderStatus = (type, data)=>{
        // 发货状态
        const badgeCourierStatus = [
            {
                type:t('order.unship'), // 未发货
                color:'magenta',
            },
            {
                type:t('order.plan'), // 计划发货
                color:'blue',
            },
            {
                type:t('order.partialShip'), // 部分发货
                color:'orange',
            },
            {
                type:t('order.shiped'), // 已发货
                color:'lime',
            },
            {
                type:t('order.signedFor'), // 已签收
                color:'green',
            },
            {
                type:t('order.canceled'), // 已关闭
                color:'#86909c',
            },
            {
                type:t('order.partialReturn'), // 部分退货
                color:'#ea7ccc',
            },
            {
                type:t('order.partialExchange'), // 部分换货
                color:'#afb2f5',
            },
            {
                type:t('order.return'), // 退回
                color:'#f71ebb',
            },
            {
                type:t('order.exchange'), // 更换
                color:'#6e74e0',
            },
            {
                type:'-',
                color:'gray',
            },
        ]

        // 出库状态
        const outboundStatus = [
            {
                type:t('order.initial'), // 初始
                color:'#ccc',
            },
            {
                type:t('order.unOutbound'), // 未出库
                color:'red',
            },
            {
                type:t('stock.outScanned'), // 已扫描
                color:'blue',
            },
            {
                type:t('order.outbound'), // 已出库
                color:'green',
            },
            {
                type:t('stock.cancelOutbound2'), // 取消出库
                color:'orange',
            },
        ]

        const typeObj = {
            'badgeCourierStatus':badgeCourierStatus,
            'outboundStatus':outboundStatus,
        }
        let item = typeObj[type].find(i=> i.type == data)
        return item && item.color
    }


    const handle = (type,row)=>{
        switch(type){
            case 'logisticsDetail':
                if(row.courier_type.trim() == 'DHL' || row.courier_type.trim() == 'Cargoboard' || row.courier_type.trim() == 'Raben'){
                    stepVisible.value = true
                    courier_no.value = row.courier_no
                    getCourierDetail(row.courier_id)
                }else if(row.courier_type == 'ZUFALL' || row.courier_type == 'SIMPLELOGISTIK'){
                    window.open(row.courier_url)
                }
                break;
        }
    }

    // 获取出库的物流信息
    const getViewLogistics = async (row)=>{
        console.log(row,'row9999')
        let param = {
            order_id:row.id,
        }
        logisticsTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getCurrierInfo(param)
        if(res.code == 0){
            logisticsTable.value.datas = []
            res.data.length > 0 && res.data.forEach((item,index)=>{
                logisticsTable.value.datas.push({
                    ...item,
                    No: index + 1,
                    sku: !item.product_map? '-' : item.product_map.sku,
                    courier_type: !item.courier_type? '-' : item.courier_type,
                    courier_no: !item.courier_no? '-' : item.courier_no,
                    courier_status: !item.courier_status? '-' : props.courierStatus[item.courier_status],
                    status: !item.status? '-' : props.outboundStatus[item.status],
                    order_name: item.order_name,
                    erp_line_no: !item.erp_line_no? '-' : item.erp_line_no,
                    product_name: !item.product_map? '-' : item.product_map.english_name,
                    happened_time: !item.happened_time? '-' : timestampToDate(item.happened_time * 1000),
                    model: item.product_map == undefined ? '-' : item.product_map.model == undefined? '-' : item.product_map.model,
                    model_year: item.product_map == undefined ? '-' : item.product_map.model_year == undefined? '-' : item.product_map.model_year,
                    brand_name: item.product_map == undefined ? '-' : item.product_map.brand_name == undefined? '-' :  item.product_map.brand_name,
                    part_name: item.product_map == undefined ? '-' : item.product_map.part_name == undefined? '-' :  item.product_map.part_name,
                })
            })
            logisticsTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流明细
    const getCourierDetail = async (id)=>{
        loading.value = true
        let res = await OrderApi.getInstance().getCourierDetail(id)
        if(res.code == 0){
            loading.value = false
            stepList.value = []
            stepList.value = res.data.map(i=>{
                return {
                    name:cargoBoardCourierDetail.value[i.code],
                    date: timestampToDate(i.happenedTime * 1000),
                    message:i.message
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取退货，换货，补寄，返修的物流信息
    const getReturnLogisticsInfo = async (row)=>{
        let param = {
            order_id:row.id,
            type: Number(activeKey.value),
        }
        returnTable.value.configs.loading = true
        let res = await OrderApi.getInstance().getReturnLogisticsInfo(param)
        if(res.code == 0){
            returnTable.value.datas = []
            res.data.length > 0 && res.data.forEach((item,index)=>{
                let currier_map = activeKey.value == 1? item.back_courier_map : activeKey.value == 2 || activeKey.value == 3 || activeKey.value == 4? item.swap_courier_map : ''
                let product_map = activeKey.value == 3? item.swap_product_map : item.product_map
                let sku = activeKey.value == 3? item.swap_sku : item.sku
                let inventory_code = activeKey.value == 3? item.swap_inventory_code : item.inventory_code
                let courier_id = activeKey.value == '0'? item.courier_id : activeKey.value == 1? item.back_courier_id : item.swap_courier_id
                returnTable.value.datas.push({
                    ...item,
                    No: index + 1,
                    sku: sku,
                    inventory_code: inventory_code,
                    courier_id:courier_id,
                    courier_type: !currier_map? '-' : currier_map.courier_type,
                    courier_no: !currier_map? '-' : currier_map.courier_no,
                    courier_status: !currier_map? '-' : !currier_map.courier_status? '-' : props.courierStatus[currier_map.courier_status],
                    order_name: item.order_name,
                    erp_line_no: !item.erp_line_no? '-' : item.erp_line_no,
                    product_name: !product_map? '-' : product_map.english_name,
                    happened_time: !item.update_date? '-' : item.update_date,
                    model: product_map == undefined ? '-' : product_map.model == undefined? '-' : product_map.model,
                    model_year: product_map == undefined ? '-' : product_map.model_year == undefined? '-' : product_map.model_year,
                    brand_name: product_map == undefined ? '-' : product_map.brand_name == undefined? '-' :  product_map.brand_name,
                    part_name: product_map == undefined ? '-' : product_map.part_name == undefined? '-' :  product_map.part_name,
                })
            })
            returnTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    watch(()=>activeKey.value,(val)=>{
        val == '0'? getViewLogistics(props.row) : getReturnLogisticsInfo(props.row)
    })

    watch(()=>props.visible,async (nVal,oVal)=>{
        activeKey.value = '0'
        returnTable.value.datas = []
        logisticsTable.value.datas = []
        await getViewLogistics(props.row)
    })

    onMounted(()=>{
        getViewLogistics(props.row)
    })


</script>

<style lang="less" scoped>
/deep/ .arco-modal-body{
    padding: 7px 20px 24px;
}

.deliverTable{
    /deep/ .arco-table-th{
        background-color: #333 !important;
        color: #fff;
        border-bottom: 1px solid #eee;
        border-right: 1px solid #eee;
        padding: 0;
        font-weight: 300;
        font-size:12px;
    }
}
</style>